import { messages, type Messages } from '../../i18n/index.js';

/**
 * таймер практики по дедлайну, а не по числу тиков (исправление P2 аудита):
 * пропущенные тики, фоновый режим и заморозка не растягивают практику.
 */

export interface LakeSession {
  /** один активный запуск: устаревшие тики от прошлых сессий игнорируются */
  id: number;
  /** момент окончания в epoch ms; null — практика на паузе */
  endsAt: number | null;
  /** остаток на паузе, ms */
  pausedMs: number;
  durationMs: number;
}

export function startSession(id: number, durationMs: number, now: number): LakeSession {
  return { id, endsAt: now + durationMs, pausedMs: durationMs, durationMs };
}

export function remainingMs(session: LakeSession, now: number): number {
  if (session.endsAt === null) return Math.max(0, session.pausedMs);
  return Math.max(0, session.endsAt - now);
}

export function pauseSession(session: LakeSession, now: number): LakeSession {
  if (session.endsAt === null) return session;
  return { ...session, pausedMs: remainingMs(session, now), endsAt: null };
}

export function resumeSession(session: LakeSession, now: number): LakeSession {
  if (session.endsAt !== null) return session;
  return { ...session, endsAt: now + Math.max(0, session.pausedMs) };
}

export function isFinished(session: LakeSession, now: number): boolean {
  return remainingMs(session, now) <= 0;
}

export function formatClock(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

/** фаза дыхания по фактически прошедшему времени: 6 секунд вдох, 5 выдох */
export function breathPhase(
  session: LakeSession,
  now: number,
  words: Messages['lake']['breath'] = messages().lake.breath,
): string {
  const elapsed = session.durationMs - remainingMs(session, now);
  return Math.floor(elapsed / 1000) % 11 < 6 ? words.in : words.out;
}
